import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Layout, Typography, Input, Button, Spin, Alert, Form, Breadcrumb } from 'antd';
import { fetchUser, updateUser } from '../../actions/UserActions';
import { UserOutlined } from '@ant-design/icons';
import { auth } from '../../App';

const { Content } = Layout;
const { Title } = Typography;

const User = () => {
  const dispatch = useDispatch();
  const { user } = useSelector(state => state.user);
  const loading = useSelector(state => state.user.userLoading);
  const error = useSelector(state => state.user.userError);

  const userID = auth.currentUser?.uid;

  const [editableFields, setEditableFields] = useState({
    names: '',
    mobile: '',
    address: '',
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (user) {
      setEditableFields({
        names: user?.names || '',
        mobile: user.mobile || '',
        address: user.address || '',
      });
    }
  }, [user]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditableFields(prevFields => ({ ...prevFields, [name]: value }));
  };

  const handleSave = () => {
    dispatch(updateUser(userID, editableFields));
  };

  return (
    <div style={{minHeight: "100vh",  padding: 20,     background: 'linear-gradient(135deg, #059941, #2f3589)'
    }}>
      {/* <Breadcrumb style={{ marginBottom: 10 }}>
        <Breadcrumb.Item>
          <UserOutlined />
        </Breadcrumb.Item>
        <Breadcrumb.Item>My Profile</Breadcrumb.Item>
      </Breadcrumb> */}

      <Content
        style={{
          maxWidth: 600,
          margin: '0 auto',
          padding: '2rem',
          backgroundColor: '#fff',
          borderRadius: 8,
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
          border: '1px solid #ddd',
        }}
      >
        {loading ? (
          <Spin size="large" style={{ display: 'block', textAlign: 'center' }} />
        ) : error ? (
          <Alert message="Error" description={error} type="error" showIcon />
        ) : (
          <Form layout="vertical">
            <Form.Item label="Name">
              <Input
                name="names"
                value={editableFields?.names}
                onChange={handleChange}
                placeholder="Enter your name"
              />
            </Form.Item>

            <Form.Item label="Mobile Number">
              <Input
                name="mobile"
                value={editableFields.mobile}
                onChange={handleChange}
                placeholder="Enter your mobile number"
              />
            </Form.Item>

            <Form.Item label="Address">
              <Input
                name="address"
                value={editableFields.address}
                onChange={handleChange}
                placeholder="Enter your address"
              />
            </Form.Item>

            <Form.Item label="Email">
              <Input value={user?.email || ''} disabled />
            </Form.Item>

            {/* <Form.Item label="Role">
              <Input value={user?.role || ''} disabled />
            </Form.Item> */}

            <Button
              type="primary"
              onClick={handleSave}
              disabled={!editableFields?.names}
              block
            >
              Save Changes
            </Button>
          </Form>
        )}
      </Content>
    </div>
  );
};

export default User;
